import {createHelpers, getField, updateField} from 'vuex-map-fields'

const {getFieldBrandComponentSpec, updateFieldBrandComponentSpec} = createHelpers({
    getterType: 'getFieldBrandComponentSpec',
    mutationType: 'updateFieldBrandComponentSpec',
});

export default {
    state: {
        brandComponentSpec: [],
        brandComponentIsAllParameters: false,
    },
    actions: {
        async fetchBrandComponentSpec(ctx, brandComponentID) {
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            const res = await fetch("/api/component_parameters/?brand_component_id=" + brandComponentID, requestParams);
            if (!res.ok) {
                this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
                return
            }
            const brandComponentSpec = await res.json();
            ctx.commit('updateBrandComponentSpec', brandComponentSpec.results)
        },
        async fetchBrandComponentCategorySpec(ctx, brandComponentCategoryID) {
            if (ctx.state.brandComponentIsAllParameters && brandComponentCategoryID != null) {
                const requestParams = {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        'credentials': "same-origin",
                    },
                };
                const res = await fetch("/api/component_category_parameters/?category=" + brandComponentCategoryID +
                    '&is_visible=True', requestParams);
                if (!res.ok) {
                    this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
                    return
                }
                const brandComponentCategorySpec = await res.json();
                ctx.commit('updateBrandComponentCategorySpec', brandComponentCategorySpec.results)
            }
        },
        async saveBrandComponentSpec(ctx, brandComponentID) {
            let csrfToken = this._vm.$readCookie('csrftoken')
            let clearBrandComponentSpec = []
            for (const brandComponentSpec of ctx.state.brandComponentSpec) {
                let display_value = brandComponentSpec.display_value
                let float_value = brandComponentSpec.float_value
                if (brandComponentSpec.unit != null) {
                    display_value = brandComponentSpec.float_value + ' ' + brandComponentSpec.unit
                    float_value = brandComponentSpec.float_value
                }
                if (brandComponentSpec.hasOwnProperty('category_param'))
                {
                    if (display_value !=  null && display_value !== '') {
                        const requestParams = {
                            method: "PATCH",
                            headers: {
                                "Content-Type": "application/json",
                                'credentials': "same-origin",
                                'X-CSRFToken': csrfToken,
                            },
                            body: JSON.stringify({
                                'display_value': display_value,
                                'float_value': float_value,
                            })
                        };
                        const res = await fetch("/api/component_parameters/" + brandComponentSpec.id + "/", requestParams);
                        if (!res.ok) {
                            this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
                        }
                        clearBrandComponentSpec.push(brandComponentSpec)
                    }
                    else {
                        const requestParams = {
                            method: "DELETE",
                            headers: {
                                "Content-Type": "application/json",
                                'credentials': "same-origin",
                                'X-CSRFToken': csrfToken,
                            },
                        };
                        const res = await fetch("/api/component_parameters/" +
                            brandComponentSpec.id + "/", requestParams);
                        if (!res.ok) {
                            this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
                        }
                    }

                }
                else if (brandComponentSpec.display_value != null || brandComponentSpec.float_value != null) {
                    const requestParams = {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                            'X-CSRFToken': csrfToken,
                        },
                        body: JSON.stringify({
                            'brand_component': parseInt(brandComponentID),
                            'category_param': brandComponentSpec.id,
                            'display_value': display_value,
                            'float_value': float_value,
                        })
                    };
                    const res = await fetch("/api/component_parameters/", requestParams);
                    if (!res.ok) {
                        this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
                    }
                    else {
                        const results = await res.json()
                        brandComponentSpec.brand_component = brandComponentID
                        brandComponentSpec.category_param = brandComponentSpec.id
                        brandComponentSpec.id = results.id
                        brandComponentSpec.display_value = display_value
                        brandComponentSpec.float_value = float_value
                    }
                    clearBrandComponentSpec.push(brandComponentSpec)
                }
            }
            ctx.commit('updateBrandComponentSpec', clearBrandComponentSpec)
        },
    },

    mutations: {
        updateFieldBrandComponentSpec,
        updateBrandComponentSpec(state, brandComponentSpec) {
            state.brandComponentSpec = brandComponentSpec
        },
        updateBrandComponentCategorySpec(state, brandComponentCategorySpec) {
            for (const spec of brandComponentCategorySpec) {
                const existed = state.brandComponentSpec.filter(column => column.section === spec.section &&
                    column.parameter === spec.parameter)
                if (existed.length === 0) state.brandComponentSpec.push(spec)
            }
        },
        updateBrandComponentIsAllParameters(state, brandComponentIsAllParameters) {
            state.brandComponentIsAllParameters = brandComponentIsAllParameters
        },
    },
    getters: {
        getFieldBrandComponentSpec,
        getBrandComponentSpec(state) {
            return state.brandComponentSpec
        },
    },
}